<template>
  <div v-if="showPage403" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <!--<div>hash {{ $route.hash }}</div>
    <div>params: {{ $route.params }}</div>
    <div>User id: {{ $route.params.id }}</div> -->
    <b-card no-body>
      <b-card-header class="custom-header">
        <div><i class="icon-note"></i> {{ title }}</div>
        <b-button-group>
          <b-button v-on:click="routerBack()" class="custom-cancel"
            ><i class="fa fa-times text-danger"></i>
            &nbsp;Cancel
          </b-button>
          <b-button
            v-on:click="post('andClose')"
            :disabled="$v.form.$invalid || submitted"
            ><i class="fa fa-save"></i>&nbsp;Save & Close</b-button
          >
          <b-button
            v-on:click="post()"
            :disabled="$v.form.$invalid || submitted"
            ><i class="fa fa-check text-success "></i>&nbsp;Apply</b-button
          >
        </b-button-group>
      </b-card-header>

      <!-- Modal Component -->
      <div>
        <Modals ref="form"></Modals>
      </div>

      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <b-row>
          <b-col md="8">
            <b-tabs>
              <b-tab title="Details" active>
                <b-form
                  v-on:submit.prevent="onSubmit"
                  v-on:reset.prevent="onReset"
                  novalidate
                >
                  <b-row style="margin">
                    <b-col md="">
                      <b-form-group
                        id="nameInputGroup1"
                        :label="loginUserInfo.db.groupName==='Admin' ? 'Company where this role belongs': 'This role belongs to company: '+ loginUserInfo.db.company.name "
                        label-class="font-weight-bold pt-0 required"
                        label-for="companyDDL"
                      >
                        <div v-if="loginUserInfo.db.groupName==='Admin'">
                          <v-select id="companyDDL" 
                            name="companyDDL"
                            v-model="seg.seg_wallet" 
                            v-model.lazy.trim="selectedCompany"
                            :options="existingCompanies" 
                            v-validate="'required'"
                            data-vv-as="companyDDL"
                            :class="{'company-invalid-border': errors.first('companyDDL')}"
                            placeholder="Choose"
                          >
                          </v-select>
                          <b-form-invalid-feedback id="folderLiveFeedback" v-if="errors.has('companyDDL')" style="display:block;">
                            A name is required.
                          </b-form-invalid-feedback>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="">
                      <!-- name -->
                      <b-form-group
                        id="nameInputGroup1"
                        label="Name"
                        label-for="name"
                        label-class="font-weight-bold pt-0 required"
                      >
                        <b-form-input
                          id="Name"
                          type="text"
                          v-model.lazy.trim="$v.form.name.$model"
                          :state="chkState('name')"
                          aria-describedby="input1LiveFeedback1"
                          placeholder="Name"
                          autocomplete="given-name"
                          autofocus
                        />
                        <b-form-invalid-feedback id="input1LiveFeedback1">
                          This is a required field and must be at least 2
                          characters
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="">
                      <b-form-group>
                        <label for="description">Description</label>
                        <b-form-textarea
                          cols="50"
                          id="basicTextarea"
                          :rows="3"
                          v-model.lazy.trim="$v.form.description.$model"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form>
              </b-tab>
              <b-tab title="Capabilities">
                <div role="tablist">
                  <ul>
                    <li
                      class="li-custom-cap"
                      v-for="navItem in navItems" :key="navItem.id"
                      v-if="navItem.showed"
                    >
                      <b-form-checkbox
                        :id="
                          `nave_${navItem.id}_${navItem.name}_chk`
                        "
                        :name="
                          `nave_${navItem.id}_${navItem.name}_chk`
                        "
                        v-model="navItem.selected"
                        @change="updateData(navItem)"
                      >
                        <i
                          :class="
                            '' +
                              navItem.icon +
                              ' nav-icon font-sl d-inline-block'
                          "
                        ></i>
                        {{ navItem.name }}
                      </b-form-checkbox>
                    </li>
                  </ul>
                  <div v-for="navItem in navItems" :key="navItem.id">
                    <b-card v-if="navItem.selected">
                      <div slot="header">
                        <i :class="'' + navItem.icon + ' nav-icon font-sl d-inline-block'"></i>
                        {{navItem.name}}
                      </div>

                    
                      <div class="no-children-nav font-size-12" v-if="!navItem.children">
                        <ul>
                          <li class="li-custom-cap" v-for="capability in navItem.capabilities" :key="capability.id"
                            v-if="capability.showed"
                          >
                            <b-form-checkbox
                              :id="`capability_${navItem.name}_chk_${capability.id}`"
                              :name="`capability_${navItem.name}_chk_${capability.id}`"
                              v-model="capability.value"
                            >
                              {{capability.label}}
                            </b-form-checkbox>
                          </li>
                        </ul>
                      </div>
                      <div class="has-children-nav font-size-12" v-else>
                        <ul>
                          <li
                            class="li-custom-cap"
                            v-for="navChild in navItem.children" :key="navChild.id"
                            v-if="navChild.showed"
                          >
                            <b-form-checkbox
                              :id="
                                `${navItem.name}_navChild_${navChild.id}_${navChild.name}_chk`
                              "
                              :name="
                                `${navItem.name}_navChild_${navChild.id}_${navChild.name}_chk`
                              "
                              v-model="navChild.selected"
                              @change="updateData(navChild)"
                            >
                              <i
                                :class="
                                  '' +
                                    navChild.icon +
                                    ' nav-icon font-sl d-inline-block'
                                "
                              ></i>
                              {{ navChild.name }}
                            </b-form-checkbox>
                          </li>
                        </ul>

                        <div v-for="navChild in navItem.children" :key="navChild.id">
                          <b-card v-if="navChild.selected">
                            <div slot="header">
                              <i :class="'' + navChild.icon + ' nav-icon font-sl d-inline-block'"></i>
                              {{navChild.name}}
                            </div>

                            <ul>
                              <li
                                class="li-custom-cap"
                                v-for="capability in navChild.capabilities"
                                :key="capability.id"
                                v-if="capability.showed"
                              >
                                <b-form-checkbox
                                  :id="
                                    `capability_${navItem.id}_${navItem.name}_${navChild.id}_${navChild.name}_chk_${capability.id}`
                                  "
                                  :name="
                                    `capability_${navItem.id}_${navItem.name}_${navChild.id}_${navChild.name}_chk_${capability.id}`
                                  "
                                  v-model="capability.value"
                                >
                                  {{ capability.label }}
                                </b-form-checkbox>
                              </li>
                            </ul>

                          </b-card>
                        </div>
                      </div>
                    </b-card>
                  </div>



                </div>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  email,
  sameAs,
  helpers
} from "vuelidate/lib/validators";
import { Switch as cSwitch } from "@coreui/vue";
import { router } from "../../router/index";
import { mapState, mapActions } from "vuex";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { apigClient } from "@/shared/api";
import vSelect from "vue-select";
import Modals from "@/shared/Modals.vue";
import nav from "../../_nav.js";
import Page403 from "@/views/pages/Page403.vue";

const Spinner = () => import("../shared/Spinner");
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};
miniToastr.init({ types: toastTypes });
function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
Vue.use(VueNotifications, options);

const formShape = {
  name: "",
  description: "",
  company_id: "",
};
let validations = {
  form: {
    name: {
      required,
      minLength: minLength(2)
    },
    description: {
      required: false
    }
  }
};
export default {
  name: "Group",
  components: {
    cSwitch,
    Spinner,
    vSelect,
    Modals,
    Page403
  },
  data() {
    // check route here, new or edit
    let newModePage = true;
    var group_name = localStorage.getItem("page_group_name");
    var group_id = localStorage.getItem("page_group_id");
    if (window.location.href.includes("/settings/role/edit")) {
      var role_id = localStorage.getItem("page_role_id");
      newModePage = false;
    }
    return {
      loginUserInfo: JSON.parse(localStorage.getItem("loginUserInfo")),
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      showPage403: false,
      newModePage: newModePage,
      title: "",
      navItems: [],
      form: Object.assign({}, formShape),
      feedBack: "secondary",
      submitted: false,
      group_name: group_name || null,
      group_id: group_id || null,
      role_id: role_id || null,
      groupCapabilities: [],
      roleCapabilities: null,
      selected: null,
      existingCompanies: [],
      selectedCompany: null,
      //roles: roles,
      disabled: true,
      isLoading: true,
      rolesValid: false,
      showFeedBackRole: false,
      groupCapaNotice: ""
    };
  },
  
  created: function() {},
  mounted: function() {
    console.log(this.loginUserInfo)
    this.checkPermission();
    this.loadData();
  },
  computed: {
    formStr() {
      return JSON.stringify(this.form, null, 4);
    },
    isValid() {
      return !this.$v.form.$anyError;
    },
    isDirty() {
      return this.$v.form.$anyDirty;
    },
    classRoles: function() {
      return {
        valid: this.rolesValid,
        "not-valid": !this.rolesValid
      };
    },
    classRolesFeedBack: function() {
      return {
        show: !this.rolesValid
      };
    }
  },
  mixins: [validationMixin],
  validations: validations,
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        } 
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    checkPermission(){
      let that = this;
      that.getPermission();
      if(that.newModePage && !that.permission.capabilities.Create){
        that.showPage403 = true;
        return;
      } else if ( !that.newModePage && !that.permission.capabilities.Edit){
        that.showPage403 = true;
        return;
      }
    },
    async loadData(){
      let that = this;
      const autoSelectCompany = (company_id) => {
        let existedCompany = that.existingCompanies.find(c => c.value === company_id);
        if(existedCompany){
          that.selectedCompany = existedCompany;
        }
      }
      if(that.loginUserInfo.db.groupName==='Admin'){
        await that.loadCompanies();
        console.log('Loaded comapnies');
      }

      if (that.role_id) {
        console.log(that.role_id);
        let roleData = await that.getRoleData(that.role_id);
        let roleCapabilities = roleData.roleCapabilities;
        autoSelectCompany(roleData.company_id);
        let groupCapabilities = await that.getGroupData(that.group_id);
        that.navItems = that.loadNavMenusAndCapabilities(groupCapabilities, roleCapabilities);
        that.title = "Group role - Edit";
        that.isLoading = false;
      } else {
        this.roleCapabilities = [];
        autoSelectCompany(that.loginUserInfo.db.company.id);
        let groupCapabilities = await that.getGroupData(that.group_id);
        console.log('loaded Group Data')
        that.navItems = that.loadNavMenusAndCapabilities(groupCapabilities, null);
        console.log('loaded NavMenus and Capabilities')
        that.title = "Create new role for Group: " + this.group_name;
        that.isLoading = false;
      }
    },
    loadCompanies: function() {
      return new Promise((resolve, reject) => {
        let that = this;
        let method = 'GET';
        let pathTemplate = '/companies';
        let params = {};
        params.filter = [
          {
            fieldname: "isDeleted",
            comparisonOperator: "=",
            value: false
          }
        ];
        let additionalParams ={
          queryParams: {
            params: JSON.stringify(params)
          }
        };
        let pathParams = {};
        apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then((result) => {
          if (result.data.status) {
            console.log('companies: ', result.data.data)
            that.existingCompanies = result.data.data.map(company => {
              let companyDDLItem = {};
              companyDDLItem.value = company.id;
              companyDDLItem.label = company.companyName;
              return companyDDLItem;
            });
            resolve('success');
          } else{
            console.log(`Cannot fetch companies! Error found from API Endpoint: ${result.data.message}`);
            reject('error');
          }
        }).catch( function(error){
          console.log('ERROR ! Cannot get company data:' + error);
          reject('error');
        });
      });
    },
    updateData(navItem) {
      let that = this;
      navItem.selected = !navItem.selected ? true : false;
      if (navItem.children) {
        navItem.children.map(children => {
          children.selected = !navItem.selected ? false : children.selected;
          children.capabilities.map(cap => {
            cap.value = !children.selected ? false : cap.value;
            return cap;
          });
          return children;
        });
      }
      if (navItem.capabilities) {
        navItem.capabilities.map(cap => {
          cap.value = !navItem.selected ? false : cap.value;
          return cap;
        });
      }
      that.$forceUpdate();
    },
    loadNavMenusAndCapabilities(existingGroupCapabilities, existingRoleCapabilities){
      console.log('existingRoleCapabilities: ', existingRoleCapabilities);
      console.log('existingGroupCapabilities: ', existingGroupCapabilities);
      existingGroupCapabilities.forEach(navItem=>{
        if(!navItem.children){
          
          // Update Mode: Enable capabilities what is used to save before
          let navItemFromDB = null;
          if(existingRoleCapabilities){
            navItemFromDB = existingRoleCapabilities.find(n=> n.id == navItem.id);
            if(navItemFromDB){
              navItem.capabilities = navItem.capabilities.map(navItemCapability => {
                let navItemCapabilityFromDB = navItemFromDB.capabilities.find(c => c.id == navItemCapability.id && c.name == navItemCapability.name);
                
                navItemCapability.showed = navItemCapability.value;
                navItemCapability.value =  navItemCapabilityFromDB.value;
                
                return navItemCapability;
              });
            }
          }else{
            // Based on group scope
            navItem.capabilities = navItem.capabilities.map(navItemCapability => {
              navItemCapability.showed = navItemCapability.value;
              return navItemCapability;
            });
          }
          
          navItem.showed = navItem.selected;
          navItem.selected = navItem.capabilities.find(c => c.value) ? true : false;
          
        } else{
          

          let navItemFromDB = null;
          if(existingRoleCapabilities){
            navItemFromDB = existingRoleCapabilities.find(n=> n.id == navItem.id);
          }
          navItem.children.forEach(childNav=>{
            
            // Update Mode: Enable capabilities what is used to save before
            let childNavFromDB = null;
            if(navItemFromDB){
              childNavFromDB = navItemFromDB.children.find(ch=> ch.id == childNav.id && ch.name == childNav.name);
              if(childNavFromDB){
                childNav.capabilities = childNav.capabilities.map(childNavItemCapability => {
                  let childNavItemCapabilityFromDB = childNavFromDB.capabilities.find(c => c.id == childNavItemCapability.id && c.name == childNavItemCapability.name);

                  childNavItemCapability.showed = childNavItemCapability.value;
                  childNavItemCapability.value =  childNavItemCapabilityFromDB.value;
                  
                  return childNavItemCapability;
                });
              }
            } else {
              // Based on group scope
              childNav.capabilities = childNav.capabilities.map(childNavItemCapability => {
                childNavItemCapability.showed = childNavItemCapability.value;
                return childNavItemCapability;
              });
            }

            childNav.showed = childNav.selected;
            childNav.selected = childNav.capabilities.find(c=> c.value===true) ? true : false;
          });

          navItem.showed = navItem.selected;
          navItem.selected = navItem.children.find(c=>c.selected===true) ? true : false;
          
        }
        return navItem;
      });
      return existingGroupCapabilities;
    },
    selectCapability(value, navItem) {
      let navItemData = this.navItems.find(n => n.name == navItem.name);
      if (navItemData) {
        if (!value) {
          //Reversed value checked:true
          navItemData.totalAllowedCapabilityCount++;
        } else {
          navItemData.totalAllowedCapabilityCount--;
        }
      }
    },
    handleChange(item) {
      // Do what you want with the selected wallets:
    },
    post: async function(option) {
      let that = this;
      const validationResult = await that.$validator.validateAll();
      console.log(validationResult);
      if(!validationResult){
        return;
      }
      console.log(that.selectedCompany);
      this.isLoading = true;
      if (this.role_id) {
        console.log(that.roleCapabilities);
        that.$refs.form.openModal();
        that.changeModalContent(
          "loading",
          "Updating...",
          "Updating Role Info"
        );
        // Do PUT to API insert into Database
        var method = "PUT";
        var pathTemplate = "/roles/" + this.role_id;
        var additionalParams = {};
        var body = {
          roleName: that.form.name,
          roleDescription: that.form.description,
          company_id: (that.loginUserInfo.db.groupName==='Admin') ? that.selectedCompany.value : that.loginUserInfo.db.company.id,
          roleCapabilities: that.navItems,
          updateBy: that.loginUserInfo.login_username
        };
        var pathParams = {};
        apigClient
          .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
          .then(function(result) {
            console.log("update a role, role_id: " + that.role_id);
            // that.showSuccessMsgCreate();
            that.changeModalContent(
              "success",
              "Updated success!",
              "The Role data has been updated"
            );
            setTimeout(() => {
              that.$refs.form.closeModal();
            }, 2000);
            
            if (option == "andClose") {
              setTimeout(() => {
                that.routerBack();
              }, 2000);
            }
          })
          .catch(function(result) {
            console.log(result);
            // that.showErrorMsg();
            that.changeModalContent(
              "error",
              "Error Occured!",
              " " + result.message
            );
          });
      } else {
        that.$refs.form.openModal();
        that.changeModalContent(
          "loading",
          "Saving...",
          "Saving Role Info"
        );
        let method = "POST";
        let pathTemplate = "/roles";
        let additionalParams = {};
        let body = {
          group_id: that.group_id,
          company_id: (that.loginUserInfo.db.groupName==='Admin') ? that.selectedCompany.value : that.loginUserInfo.db.company.id,
          roleName: that.form.name,
          roleDescription: that.form.description,
          roleCapabilities: that.navItems,
          createBy: that.loginUserInfo.login_username
        };
        let pathParams = {};
        apigClient
          .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
          .then(function(result) {
            console.log(
              "create a new role, role_id: " + result["data"]["data"]
            );
            // that.showSuccessMsgCreate();
            that.changeModalContent(
              "success",
              "Saved success!",
              "The Role data has been created"
            );
            if (option == "andClose") {
              localStorage.setItem("page_role_id", result["data"]["data"]);
              setTimeout(() => {
                that.routerBack();
              }, 2000);
            }
          })
          .catch(function(result) {
            console.log(result);
            that.changeModalContent(
              "error",
              "Error Occured!",
              " " + result.message
            );
          });
      }
      this.isLoading = false;
    },
    routerBack() {
      this.$router.go(-1);
    },
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          // submit
          // console.log('submit:', this.formStr)
          this.submitted = true;
          this.feedBack = "info";
        });
      }
    },
    changeModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.form.status = status ? status : that.$refs.form.status;
      that.$refs.form.title = title ? title : that.$refs.form.title;
      that.$refs.form.message = message ? message : that.$refs.form.message;
    },
    onReset() {
      // Reset validation
      this.form = Object.assign({}, formShape);
      this.submitted = false;
      this.$nextTick(() => {
        this.$v.$reset();
        this.feedBack = "secondary";
      });
    },
    chkState(val) {
      const field = this.$v.form[val];
      return (field.$model !== '' && field.$model !== undefined) ? !field.$dirty || !field.$invalid : null;
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus();
          return true;
        }
        if (component.$refs.check) {
          component.$refs.check.focus();
          return true;
        }
      }
      let focused = false;
      component.$children.some(child => {
        focused = this.findFirstError(child);
        return focused;
      });
      return focused;
    },
    validate() {
      this.$v.$touch();
      this.$nextTick(() => this.findFirstError());
      return this.isValid;
    },
    getGroupData: function(group_id) {
      return new Promise((resolve, reject) => {
        let method = "GET";
        let pathTemplate = "/groups/" + group_id;
        let additionalParams = {};
        let pathParams = {};
        apigClient
          .invokeApi(pathParams, pathTemplate, method, additionalParams)
          .then(result => {
            if (result.data.status) {
              console.log('Group Data: ', result.data.data);
              let groupCapabilities = result.data.data['groupCapabilities'];
              resolve(groupCapabilities);
            }else{
              console.log('Cannot get Group Data Error:', result.data.message );
              reject('error');
            }
          })
          .catch(function(error) {
            console.log('Cannot get Group Data Error:', error.message);
            reject('error');
          });
      });
    },
    getRoleData: function(role_id) {
      return new Promise((resolve, reject) => {
      let method = "GET";
      let pathTemplate = "/roles/" + role_id;
      let additionalParams = {};
      let pathParams = {};
      let that = this;
      
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          console.log("role data=", result.data.data);
          if(result.data.status){
            let roleData = result.data.data;
            that.group_id = roleData.group_id;
            that.form.name = roleData.roleName;
            that.form.description = roleData.roleDescription=='NULL' ? '': roleData.roleDescription;
            resolve(roleData);
          } else {
            console.log('Cannot get Role Data Error:', result.data.message );
            reject('error');
          }
        })
        .catch(function(error) {
          console.log('Cannot get Role Data Error:', error.data.message );
          reject('error');
        });
      });
    }
  },
  notifications: {
    showSuccessMsgCreate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The role has been created"
    },
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The role has been updated"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "Info",
      message: "Here is some info for you"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Warning",
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "ERROR",
      message: "The role cannot be saved"
    }
  }
};
</script>

<style scoped>
.btn.disabled {
  cursor: auto;
}
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  border: 1px solid #a4acb5;
}
@media only screen and (max-width: 600px) {
  .custom-header {
    flex-direction: column;
    align-items: inherit;
  }
  .custom-header > div:first-child {
    margin-bottom: 10px;
  }
}
.custom-cancel {
  border-radius: 0.25rem 0 0 0.25rem;
}
.sk-fading-circle .sk-circle {
  margin: 0 auto;
}
.sk-three-bounce {
  height: 40px;
}
.valid {
  border: 1px solid #4dbd74;
  border-radius: 0.25rem;
}
.not-valid {
  border: 1px solid #f86c6b;
  border-radius: 0.25rem;
}
.li-custom {
  list-style-type: none;
}

#language {
  margin-top: 15px;
}

select {
  /* for Firefox */
  -moz-appearance: none;
  /* for Chrome */
  -webkit-appearance: none;
}
/* For IE10 */
select::-ms-expand {
  display: none;
}
.show {
  display: block;
}
.li-custom {
  list-style-type: none;
}
ul {
  padding-left: 0;
}
.menu-title {
  font-size: 13px !important;
}
.company-invalid-border >>> .dropdown-toggle{
  border-color:#f86c6b !important;
}
.is-valid-border >>> .dropdown-toggle{
  border-color:#4dbd74 !important;
}
</style>
<style lang="less">
.li-custom-cap {
  list-style-type: none;
  display: inline-block;
  margin: 0px 15px 9px 0px;

  .custom-checkbox label.custom-control-label {
    padding-top: 2px !important;
    font-size: 13px !important;
  }
}
.font-size-12 {
  font-size: 12px !important;
}
</style>
